import styled, { css } from 'styled-components';

import { FaArrowCircleLeft, FaArrowCircleRight } from "react-icons/fa";

export const FaArrowCircleLeftIcon = styled(FaArrowCircleLeft)`
    width: 25px;
    height: 25px;

    border-radius: 3px;

    padding-right: 5px;

    cursor: pointer;

    &:hover {
        opacity: .7;
    }
`;

export const FaArrowCircleRightIcon = styled(FaArrowCircleRight)`
    width: 25px;
    height: 25px;

    border-radius: 3px;

    padding-right: 5px;

    cursor: pointer;

    &:hover {
        opacity: .7;
    }
`;

export const Container = styled.div`

    padding: 15px 0;
    display: flex;
    justify-content: center;
    align-items: center;

    > p {
        margin: 0;
        font-size: 12px;
        color: black;
    }
    
`;

export const PaginationBox = styled.div`

    padding: 15px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    
`;

export const PaginationButton = styled.button`

    width: 40px;
    height: 40px;
    border-radius: 4px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid black;
    cursor: pointer;

    :disabled {
        border: 1px solid #c2c2c2;
        cursor: unset;
    }
    
`;